import { FunctionComponent } from 'react'
import { LiveEventTransformedHockey } from '@utils/formatters/hockey'
import SportsHeaderComponents from '@components/Teaser/SportsHeader'
import InfoTitle from './InfoTitle'
import SportsTeam from './SportsTeam'

const { HalvesHeader, LeftHalf, MiddleInfo, RightHalf, Score } =
  SportsHeaderComponents

interface HeaderHockeyProps {
  data: LiveEventTransformedHockey
}

const HeaderHockey: FunctionComponent<HeaderHockeyProps> = ({ data }) => {
  const { isLive, statusTitle, teams, isScheduled, scoreExplanation } = data

  const [homeTeam, awayTeam] = teams && teams.length ? teams : [null, null]

  const isScoreAvailable = !isScheduled
  const hasEnded = !isLive && !isScheduled

  if (!homeTeam || !awayTeam) {
    return null
  }

  return (
    <HalvesHeader>
      <LeftHalf>
        <SportsTeam team={homeTeam} align="left" />
      </LeftHalf>

      <MiddleInfo infoTitleShown={!hasEnded}>
        {!hasEnded ? (
          <InfoTitle isLive={isLive}>{statusTitle}</InfoTitle>
        ) : null}
        {isScoreAvailable ? (
          <Score
            homeTeam={homeTeam.score}
            awayTeam={awayTeam.score}
            scoreExplanation={scoreExplanation}>
            :
          </Score>
        ) : null}
      </MiddleInfo>

      <RightHalf>
        <SportsTeam team={awayTeam} align="right" />
      </RightHalf>
    </HalvesHeader>
  )
}

export default HeaderHockey
